export type UserGetMeDto = {
    talentId?: string
    talentTradingName?: string
    giggedClientId?: string
    giggedClientName?: string
    giggedClientDisplayName?: string
    giggedClientIsVerified?: boolean
    organizationName?: string
    userClaims: UserClaimDto[]
    /** Persisted Nylas fields on the user (grant, calendar, provider, email); does not prove live access. */
    hasCalendarGrant: boolean
    /** Result of the latest calendar health evaluation for talent; true for non-talent. */
    isCalendarOperational: boolean
    lastCalendarHealthCheckedAt?: string | null
    usedCachedCalendarHealth?: boolean
    /** Connected calendar provider (e.g. "google", "microsoft"); null when not connected. */
    calendarProvider?: string | null
    /** Email of the connected calendar account; null when not connected. */
    calendarEmail?: string | null
}

export type UserClaimDto = {
    claimTypeId: number
    claimTypeName: string
}

export enum UserRole {
    Default = 0,
    Sales = 1,
    Resources = 2,
    AC = 3,
    Admin = 4,
    Global = 5
}